<template>
    <div id="createContentItem" v-on:click="onCreateContentClicked">
		<svg class="addBtn">
			<line x1="25" y1="0" x2="25" y2="50" stroke-width="2" />
			<line x1="0" y1="25" x2="50" y2="25" stroke-width="2" />
		</svg>
		<div class="title">Neuen Inhalt hochladen</div>
	</div>
</template>

<script>
import {EventBus} from '@/services/EventBus.js';

export default {
	name: "CreateContentItem",
	props: [
		"type"
	],
	methods: {
		onCreateContentClicked() {
			//console.log("-> create new content for type: "+this.type);
			EventBus.$emit('onNewSlide', this.type);
		}
	}
}
</script>

<style scoped>
    #createContentItem {
		font-family: "BrownLLWeb-Regular";
		width: 233px;
		height: 128px;
        margin: 25px 0px 0px 25px;
		border: solid 1px black;
		background-color: white;
		color: black;
	}

	#createContentItem:hover {
		cursor: pointer;
		background-color: black;
		color: white;
	}

	.addBtn {
		height: 50px;
		margin-left: 90px;
        margin-top: 25px;
		stroke: black;
	}

	#createContentItem:hover .addBtn {
		stroke: white;
	}
	
	.title {
		font-size: 18px;
		width: 233px;
		margin-top: 15px;
		text-align: center;
	}
</style>